<template>
  <div>
    <div v-if="membershipFee.attributes">
      <div class="mb-4 mt-6">
        <div class="mb-2 border-b border-gray-dark pb-2">
          <span
            class="font-bold"
            v-text="`$${membershipFee.attributes.amount} ${membershipFee.attributes.payment_interval}`"
          />
          <span
            class="italic"
            v-text="` - ${membershipFee.attributes.split_description}`"
          />
        </div>
      </div>
      <button
        class="btn btn--sm"
        type="button"
        @click="$emit('showForm')"
        v-text="`Update ${membershipFee.attributes.title}`"
      />
    </div>
    <div v-else>
      Loading...
    </div>
  </div>
</template>

<script type="text/babel">

import { mapState } from 'vuex'

export default {
  name: 'MembershipFeeInfo',
  computed: {
    ...mapState({
      membershipFee: state => state.payments.membershipFee,
    }),
  },
}
</script>
